module.exports = __webpack_public_path__ + "static/img/G.acc9e97.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jlbs/G.png
// module id = DZ0v
// module chunks = 0